export default {
  valueType: 'date',
  FormItemProps: {
    label: '日期',
    rules: [],
    style: {}
  },
  ControlProps: {
    disabled: false,
    placeholder: "请选择",
    style: {}
  },
}
